export default function WalletNewIcon() {
  return <img height='183px' width='190px' src='/wallet-new.png' />
}
